/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

export const useModal = (id: string, isOpen: boolean) => {
    const [container, setContainer] = useState<HTMLElement | null>(null);

    useEffect(() => {
        if (!isOpen) {
            setContainer(null);
            return;
        } else {
            const modelRoot = document.createElement("div");
            modelRoot.setAttribute("id", `modal-${id}`);
            document.body.appendChild(modelRoot);
            setContainer(modelRoot);
            return () => {
                document.body.removeChild(modelRoot);
            };
        }
    }, [isOpen]);

    return container;
};
